import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subQuote: false,
  subJobsheet: false,
  subOrders: false,
  subStore: false,
  subDocs: false,
  subDiecut: false,
  subProd: false,
  subUser: false, // Added for user management
};

export const pageSlice = createSlice({
  name: "pages",
  initialState,
  reducers: {
    toggleQuote: (state) => {
      state.subQuote = !state.subQuote;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleJobsheet: (state) => {
      state.subJobsheet = !state.subJobsheet;
      state.subQuote = false;
      state.subOrders = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleOrders: (state) => {
      state.subOrders = !state.subOrders;
      state.subJobsheet = false;
      state.subQuote = false;
      state.subStore = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleStore: (state) => {
      state.subStore = !state.subStore;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleDocs: (state) => {
      state.subDocs = !state.subDocs;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDiecut = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleDiecut: (state) => {
      state.subDiecut = !state.subDiecut;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subProd = false;
      state.subUser = false; // Reset user management section
    },
    toggleProd: (state) => {
      state.subProd = !state.subProd;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
      state.subUser = false; // Reset user management section
    },
    toggleUser: (state) => {
      state.subUser = !state.subUser;
      state.subProd = false;
      state.subJobsheet = false;
      state.subOrders = false;
      state.subStore = false;
      state.subQuote = false;
      state.subDocs = false;
      state.subDiecut = false;
    },
  },
});

export const {
  toggleQuote,
  toggleJobsheet,
  toggleOrders,
  toggleStore,
  toggleDocs,
  toggleDiecut,
  toggleProd,
  toggleUser,
} = pageSlice.actions;

export default pageSlice.reducer;
